module.exports = __webpack_public_path__ + "img/Color.f171877f.png";